export default {
    locate: 'Locate',
    notAvailable: 'Not Available',
    order: 'Order',
    stock: 'In Stock',
    inTransit: 'In Transit',
    tbd: 'Stock TBD',
};
